import { UseFormReturn } from 'react-hook-form'
import {
  LoadConfirmationModule,
  LoadConfirmationFormValues,
  CarrierContactDetails,
} from 'modules/load-confirmation'
import { TripPayload } from 'store/trips/trips.types'
import { Order } from 'store/orders/orders.types'
import { useSendToCarrier } from './use-send-to-carrier'

export type LoadConfirmationDialogProps = {
  open: boolean
  onClose: () => void
  formMethods: UseFormReturn<LoadConfirmationFormValues>
  tripTasks: TripPayload[]
  allOrders: Order[]
  existingCarrierOrder?: Order | null
  tripCarrier?: {
    carrierName?: string
    carrierCompanyId?: string
  } | null
  prefilledCarrierContact?: CarrierContactDetails | null
  skipCarrierAutoFill?: boolean
  onSaved?: (result?: unknown) => void | Promise<void>
}

const LoadConfirmationDialog = (props: LoadConfirmationDialogProps) => {
  const { sendToCarrier } = useSendToCarrier()

  return (
    <LoadConfirmationModule
      {...props}
      onSave={sendToCarrier}
      enableCarrierTripBuilder
    />
  )
}

export default LoadConfirmationDialog
